import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M35.666 47.852c.029-.029.068-.038.1-.065s.034-.065.062-.092L59.88 23.639a3.149 3.149 0 0 1 4.454 4.454L42.347 50.079l21.828 21.828a3.149 3.149 0 1 1-4.453 4.454L35.666 52.305a3.148 3.148 0 0 1 0-4.453z'

const IconCaretLeft: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconCaretLeft
